import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { SingleOption } from '../../model/singleOption';
import { AnswersRepositoryService } from '../../services/answers-repository.service';
import { CategoryQuestionss } from '../../services/client/model/categoryQuestions';
import { Question } from '../../services/client/model/question';
import { AnswerByCategory } from '../../services/client/model/answerByCategory';
import { QuestionAnswer } from '../../services/client/model/questionAnswer';

@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.css'],
})
export class PollComponent implements OnInit, AfterViewInit {
  @Input() categoryQuestions: CategoryQuestionss;
  @Input() progressValue: number;
  @Output() buttonClick = new EventEmitter<string>();
  @Input() stepNumber: string;
  @Input() totalSteps: string;
  currentOptions: SingleOption[][];

  subcategoryIteration: number;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private answersRepository: AnswersRepositoryService,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.retrievePreviousAnswers('paintSmiles');
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.updateCurrentOptions();
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      categoryQuestions: this.fb.array([]),
      observation: [''],
    });
    this.currentQuestions.forEach(() => this.addQuestion());
    this.retrievePreviousAnswers('setValues');
  }

  updateCurrentOptions() {
    this.currentOptions = this.currentQuestions.map((question) =>
      this.optionsFrom(question),
    );
  }

  addQuestion() {
    this.formQuestions.push(this.fb.control('', Validators.required));
  }

  get category() {
    return this.categoryQuestions.category;
  }

  get categoryTitle() {
    return this.category.title;
  }

  get categorySubtitle() {
    return this.category.subtitle;
  }

  get currentQuestions() {
    return this.categoryQuestions.questions;
  }

  get formQuestions() {
    return this.form.get('categoryQuestions') as FormArray;
  }

  getInvalidAnswer(index: number) {
    return (
      this.formQuestions.controls[index].invalid &&
      (this.formQuestions.controls[index].touched ||
        this.formQuestions.controls[index].dirty)
    );
  }

  optionsFrom(question: Question) {
    return question.options.map((option) => {
      const currentOption: SingleOption = {
        name: 'option_' + question.id.toString(),
        value: option.value,
        description: option.description,
      };
      return currentOption;
    });
  }

  handleBackClick() {
    this.buttonClick.emit('back');
  }

  saveChanges() {
    if (this.form.invalid) {
      Object.values(this.form.controls).forEach((control) => {
        control.markAllAsTouched();
      });
    } else {
      const categoryAnswer: AnswerByCategory = {
        category_id: this.category.id,
        category_answers: [],
        observation: this.form.get('observation').value,
      };
      for (let index = 0; index < this.currentQuestions.length; index++) {
        const questionAnswer: QuestionAnswer = {
          question_id: this.currentQuestions[index].id,
          option_value: this.formQuestions.controls[index].value,
        };
        categoryAnswer.category_answers.push(questionAnswer);
      }
      console.log(categoryAnswer);
      this.answersRepository.addAnswer(categoryAnswer);
      this.buttonClick.emit('next');
    }
  }

  retrievePreviousAnswers(action: string) {
    const previousAnswers = this.answersRepository.getPreviousAnswers(
      this.category.id,
    );
    if (previousAnswers) {
      if (action === 'setValues') {
        this.formQuestions.controls.forEach((control) => {
          const index = this.formQuestions.controls.indexOf(control);
          control.setValue(
            previousAnswers.category_answers[index].option_value,
          );
        });
        this.form.get('observation').setValue(previousAnswers.observation);
      }
      // Paint Smiles
      else {
        this.formQuestions.controls.forEach((control) => {
          const index = this.formQuestions.controls.indexOf(control);
          const name =
            '[name="option_' +
            previousAnswers.category_answers[index].question_id +
            '"]';
          const value =
            '[value="' +
            previousAnswers.category_answers[index].option_value +
            '"]';
          const element: HTMLElement =
            this.elementRef.nativeElement.querySelector(name + value);
          element.click();
        });
      }
    }
  }
}
